(function () {
    function initClientTestimonials(root) {
        if (!root || typeof Swiper === 'undefined') return;

        var slider = root.querySelector('.client-testimonials__slider');
        if (!slider) return;

        if (slider.swiper && typeof slider.swiper.destroy === 'function') {
            slider.swiper.destroy(true, true);
        }

        var isRtl = document.documentElement.dir === 'rtl';
        slider.setAttribute('dir', isRtl ? 'rtl' : 'ltr');

        var swiper = new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 18,
            speed: 550,
            loop: false,
            centeredSlides: false,
            watchOverflow: true,
            navigation: {
                prevEl: root.querySelector('.client-testimonials__button--prev'),
                nextEl: root.querySelector('.client-testimonials__button--next')
            },
            pagination: {
                el: root.querySelector('.client-testimonials__pagination'),
                clickable: true
            },
            breakpoints: {
                750: {
                    slidesPerView: 3,
                    spaceBetween: 42,
                    centeredSlides: false
                }
            }
        });

        if (typeof swiper.changeLanguageDirection === 'function') {
            swiper.changeLanguageDirection(isRtl ? 'rtl' : 'ltr');
        }
    }

    function initAllClientTestimonials() {
        document.querySelectorAll('[data-client-testimonials]').forEach(initClientTestimonials);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAllClientTestimonials, { once: true });
    } else {
        initAllClientTestimonials();
    }

    document.addEventListener('shopify:section:load', function (event) {
        var section = document.getElementById('ClientTestimonials-' + event.detail.sectionId);
        initClientTestimonials(section);
    });
})();
